
import Vue from 'vue'

import CustomTextModal from './CustomTextModal.vue'
import { RButton } from '@/components'

import { mapActions, mapGetters } from 'vuex'
import { isAlreadyPending } from '@/store/root'
import { getInsufficientCapacityCoupon, Coupon } from '@/services/coupons'

export default Vue.extend({
  name: 'CapacityModal',
  components: {
    CustomTextModal,
    RButton,
  },
  props: {
    name: {
      type: String,
    },
  },
  computed: {
    userName(): string {
      return this.name ? this.name : 'Renderro User'
    },
    coupon(): Coupon {
      return getInsufficientCapacityCoupon()
    },
    codeValue(): string | number {
      return this.coupon.value
    },
    code(): string {
      return this.coupon.code
    },
    redeemCodeRequestPending(): boolean {
      return isAlreadyPending(this.redeemCodeRequest)
    },
    ...mapGetters({
      redeemCodeRequest: 'payment/redeemCodeRequest',
    }),
  },
  methods: {
    async handleRedeem(): Promise<void> {
      await this.redeemCode(this.code)
    },
    ...mapActions({
      redeemCode: 'payment/redeemCode',
    }),
  },
})
